"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _AdButlerAds = _interopRequireDefault(require("./AdButlerAds.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CenteredDiv = _styledComponents.default.div.withConfig({
  displayName: "AdButlerAds__CenteredDiv",
  componentId: "sc-vzln7p-0"
})(["display:flex;align-items:center;justify-content:center;padding:40px;margin:0 auto;"]);
var AdButlerAds = function AdButlerAds(props) {
  var imgUrl = props.imgUrl,
    altText = props.altText,
    target = props.target,
    width = props.width,
    height = props.height,
    redirectUrl = props.redirectUrl,
    theme = props.theme,
    customProperties = props.customProperties,
    children = props.children;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(CenteredDiv, null, /*#__PURE__*/_react.default.createElement("a", {
      href: redirectUrl,
      target: target,
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
      src: imgUrl,
      alt: altText,
      width: width,
      height: height
    }, customProperties, {
      style: {
        boxShadow: 'none'
      }
    }))), children && /*#__PURE__*/_react.default.createElement("div", null, children));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
AdButlerAds.propTypes = _AdButlerAds.default.PropTypes;
AdButlerAds.defaultProps = _AdButlerAds.default.DefaultProps;
var _default = AdButlerAds;
exports.default = _default;